export default __webpack_public_path__ + "static/media/2.326ecfd6.png";